import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  styled,
  Typography,
} from '@mui/material';
import React, { FunctionComponent } from 'react';
import { ActivePlan } from '../PaymentType';
import SubscriptionImage from '../../../../src/assets/images/subscription.png';
import Image from 'components/Image';
import axiosInstance from 'utils/axios';
import { BILLING_CANCEL_SUBSCRIPTION_API_URL } from 'api/apiConstants';
import { useSnackbar } from 'notistack';
import usePortalId from 'hooks/portal/usePortalId';
import { useNavigate } from 'react-router-dom';
import { fDate } from 'utils/formatTime';
import { useTranslation } from 'react-i18next';
import { ROOT_NAVIGATION } from 'routes/paths';

type Props = {
  activePlan: ActivePlan;
  isSubscribed: boolean;
};

const ContentStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(15, 0, 0),
}));

const SubscriptionCancel: FunctionComponent<Props> = ({
  activePlan,
  isSubscribed,
}) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const portalId = usePortalId();
  const cancelSubscription = async () => {
    try {
      const response = await axiosInstance.delete(
        `${BILLING_CANCEL_SUBSCRIPTION_API_URL}?portal_id=${portalId}`
      );
      enqueueSnackbar(t('subscription_cancelled'), { variant: 'success' });
      navigate('/');
    } catch (error: any) {
      enqueueSnackbar(error.data.message, { variant: 'error' });
    }
  };

  return (
    <Container>
      <ContentStyle>
        <Box>
          <Grid container spacing={8}>
            <Grid item xs={12} md={12}>
              <Grid container columnSpacing={10} direction='column' spacing={4}>
                <Grid sx={{ textAlign: 'center', width: '100%' }} item xs={8}>
                  <Card sx={{ p: 3 }}>
                    <Button
                      sx={{ float: 'left' }}
                      variant='outlined'
                      href={ROOT_NAVIGATION.general.home(portalId)}
                    >
                      {t('back')}
                    </Button>
                    {isSubscribed ? (
                      <>
                        <Image
                          sx={{
                            width: '50%',
                            objectFit: 'contain',
                            margin: '0 auto',
                          }}
                          visibleByDefault
                          disabledEffect
                          src={SubscriptionImage}
                          alt='login'
                        />
                        <Typography
                          sx={{ mt: 4, mb: 2 }}
                          variant='h2'
                          component='div'
                        >
                          {t('plan_subscribed')}
                        </Typography>
                        <Typography
                          variant='body2'
                          sx={{ color: 'text.secondary', mt: 2, mb: 2 }}
                          noWrap
                        >
                          {t('you_have_been_subscribed_to')} {''}$
                          {activePlan.subscription?.amount} {'/'} {t('month')}{' '}
                          {t('your_subscription_will_end_on')}{' '}
                          {fDate(Number(activePlan.validity))}
                        </Typography>
                        <Typography
                          variant='body2'
                          sx={{ color: 'text.secondary', mt: 2, mb: 5 }}
                          noWrap
                        >
                          {t('your_next_payment_date_is')} {''}
                          {fDate(
                            Number(activePlan.subscription?.next_payment_date)
                          )}
                        </Typography>
                        <Button
                          onClick={cancelSubscription}
                          variant='contained'
                          color='error'
                        >
                          {t('cancel_subscription')}
                        </Button>
                      </>
                    ) : (
                      <Typography
                        sx={{ mt: 4, mb: 2 }}
                        variant='h6'
                        component='div'
                      >
                        {t('something_went_wrong_contact_admin')}
                      </Typography>
                    )}
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </ContentStyle>
    </Container>
  );
};
export default SubscriptionCancel;
